<template>
  <div>
    <header>
  
      <!-- Navbar -->
      <nav class="head-sp-nav navbar navbar-expand-lg navbar-dark head-nav">
        <div class="container">
  
          <a class="navbar-brand" @click="jump(0)">
            <img class="pc-only-i main_icon" src="/static/img/main_icon.jpg">
            <img class="sp-only-i main_icon" src="/static/img/main_icon.jpg">
          </a>
  
          <!-- Collapse 
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
            aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>-->
  
          <ul class="sp-nav">
            <template v-if="token == null || token == ''">
              <li class="sp-nav-child sp-regist" @click="jump(1)">
                <div class="icon-parent">
                  <img class="" src="/static/img/icon/signup.png" style="height: 25px;">
                  <span class="sp-icon oi oi-people"></span>
                </div>
                <span class="sp-icon-font">新規登録</span>
              </li>
              <li class="sp-nav-child sp-login" @click="jump(2)">
                <div class="icon-parent">
                  <img class="" src="/static/img/icon/login.png" style="height: 25px;">
                </div>
                <span class="sp-icon-font">ログイン</span>
              </li>
            </template>
            <template v-if="token != null && token != ''">
              <li class="sp-nav-child sp-mypage" data-url="" @click="jump(3)" v-show="$route.path!='/mypage'">
                <div class="icon-parent">
                  <img class="" src="/static/img/icon/mypage.png" style="height: 25px;">
                </div>
                <span class="sp-icon-font">マイページ</span>
              </li>
              <li class="sp-nav-child sp-logout" @click="logout()">
                <div class="icon-parent">
                  <img class="" src="/static/img/icon/logout.png" style="height: 25px;">
                </div>
                <span class="sp-icon-font">ログアウト</span>
              </li>
              <li class="sp-nav-child sp-button" data-url="" v-show="$route.path=='/mypage'">
                <b-button v-b-toggle.sidebar-backdrop class="menu-btn">
                  <div class="icon-parent"><img src="/static/img/icon/menu-button.png" style="height: 25px;"></div>
                  <span class="sp-icon-font">メニュー</span>
                  <!--<b-icon icon="list" aria-hidden="true" dark></b-icon>-->
                </b-button>
              </li>
            </template>
          </ul>
  
          <!-- Links -->
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
    
            <!-- Left -->
            <ul class="navbar-nav mr-auto">
            </ul>
    
            <!-- Right -->
            <template v-if="token == null || token == ''">
              <ul class="navbar-nav nav-flex-icons">
                <li class="mr-1 ml-1 pr-2 pl-2">
                  <a @click="jump(1)" style="border-radius: 4px;color: rgb(169 169 169);background-color: #fbfcad;" class="org_btn nav-link rounded">
                    新規登録
                  </a>
                </li>
                <li class="mr-1 ml-1 pr-2 pl-2">
                  <a @click="jump(2)" style="border-radius: 4px;color: #fefefe;background-color: #edbb4b;" class="l org_btn nav-link rounded">
                    ログイン
                  </a>
                </li>
              </ul>
            </template>
            <template v-if="token != null && token != ''">
              <ul class="navbar-nav nav-flex-icons">
                <li class="mr-1 ml-1 pr-2 pl-2" v-show="$route.path!='/mypage'">
                  <a @click="jump(3)" style="border-radius: 4px;color: rgb(169 169 169);background-color: #fbfcad;" class="org_btn nav-link rounded">
                    マイページ
                  </a>
                </li>
                <li class="mr-1 ml-1 pr-2 pl-2">
                  <a @click="logout()" style="border-radius: 4px;color: #fefefe;background-color: #edbb4b;" class="l org_btn nav-link rounded">
                    ログアウト
                  </a>
                </li>
              </ul>
            </template>

          </div>
    
        </div>
      </nav>
      <!-- Navbar -->
      <!--
      <div>{{ $route.path }}</div>
      <div>{{ $route.params }}</div>
      <div>{{ $route.fullPath }}</div>
      <div>{{ $route.name }}</div>
      -->
    </header>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'Header',
  data() {
    return {
      isGuest: true,
      user: {},
    }
  },
  mounted() {
  },
  methods: {
    is_mobile() {
      if (window.matchMedia && window.matchMedia('(max-device-width: 640px)').matches) {
        return true;
      } else {
        return false;
      }
    },
    jump(number) {
      if (number==0) {
        this.$router.push({path: '/'});
      } else if (number==1) {
        this.$router.push({path: '/sign_up?user_type=1'});
      } else if (number==2) {
        this.$router.push({path: '/login'});
      } else if (number==3) {
        this.$router.push({path: '/mypage'});
      }
    },
    async logout() {
      this.$store.dispatch('auth/logout', {});
    },
    /*
    * user show
    */
    async current_user() {
      this.$store.dispatch('user/current_user')
      .then(res => {
        this.user = res.data.users;
        console.log(this.user);
      }, error => {
        // バックエンドからエラーが返却された場合、ひとまずアラートでメッセージを出力
        console.log(error);
        // if ('error' in error.response.data) {
        //   alert(error.response.data['error']);
        //   window.scrollTo({
        //     top: 0,
        //   });
        // }
      });
    },
  },
	computed: {
		...mapState('auth', ['token']),
		token: function() {
			return this.$store.getters["auth/token"];
		},
    // isMypage() {
    //   return location.pathname.indexOf("mypage")!=-1;
    // }
	},
  created() {
    if ( this.token != null && this.token != '' ) {
      this.current_user();
    }
    // window.addEventListener('resize', this.onWindowResize)
  },
  destroyed() {
    // window.removeEventListener('resize', this.onWindowResize)
  }
}
</script>

<style>

html,
body,
.carousel {
  height: 20vh;
}
/*
header {
  height: 100px;
}*/
.main_icon {
  max-height: 35px;
}

@media all and (-ms-high-contrast: none) {
  header {
    height: auto;
  }
}
@media (max-width: 740px) {
  html,
  body,
  .carousel {
    height: 33vh;
  }
  /*
  header {
    height: 100px;
  }*/
}
@media (min-width: 800px) and (max-width: 850px) {
  html,
  body,
  .carousel {
    height: 33vh;
  }
  /*
  header {
    height: 100px;
  }*/
}

/*@media (min-width: 800px) and (max-width: 850px) {
.navbar:not(.top-nav-collapse) {
background: #929FBA!important;
}
}*/

@media (max-width: 767px) {
  .main_icon {
     max-height: 25px;}
}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue